import { homeIcon } from "../../../core/elements/icons/index.js";
import entryWidget from "./entryWidget.js";

/*
 * I am a concrete implementation of `entryWidget' in the case
 * my model is a `folder'.
 *
 * I only override the click action.
 */

/**
 * Todo: Add JSDoc comment
 */
function folderWidget(spec, my) {
	spec ||= {};
	my ||= {};

	const that = entryWidget(spec, my);

	my.onClickAction = function () {
		my.trigger("folderClicked", that.model());
	};

	my.listIcon = function () {
		if (that.model().isRoot()) {
			return homeIcon.getCssClass();
		}
		return "fa fa-folder-open";
	};

	my.icon = function () {
		if (that.model().isRoot()) {
			return homeIcon.getCssClass();
		}
		return "di-folder";
	};

	return that;
}

export default folderWidget;
